/* eslint-disable camelcase */
import { Helper } from '../../../common/helpers/Helper'

function upper(value) {
  return String(value == null ? '' : value).trim().toUpperCase()
}

function lower(value) {
  return String(value == null ? '' : value).trim().toLowerCase()
}

function safeStr(value) {
  return value == null ? '' : String(value)
}

function variablesToArray(variableValues) {
  if (!variableValues) return []
  if (Array.isArray(variableValues)) return variableValues
  if (typeof variableValues === 'object') return Helper.dictToArray(variableValues)
  return []
}

function pickMediaLink(comp) {
  const link = safeStr(comp && comp.mediaLink).trim()
  if (link) return link
  const media = safeStr(comp && comp.media).trim()
  return media
}

function setExampleAtVIndex(targetArray, vIndex, value) {
  const idx = Number.isInteger(vIndex) && vIndex > 0 ? vIndex : 1
  const slot = idx - 1
  while (targetArray.length <= slot) targetArray.push('')
  targetArray[slot] = value
}

export function buildPreviewComponentsFromTemplate(structureComponents, variableValues, options = {}) {
  const components = Array.isArray(structureComponents) ? structureComponents : []
  if (components.length === 0) return []
  const hideTemplateExamplesWhenUnset = !!(options && options.hideTemplateExamplesWhenUnset)

  const variables = variablesToArray(variableValues)

  const headerTextVars = variables.filter(v => upper(v && v.type) === 'HEADER' && lower(v && v.format) === 'text')
  const headerMediaVar = variables.find(v => upper(v && v.type) === 'HEADER' && ['image', 'video', 'document'].includes(lower(v && v.format)))
  const bodyVars = variables.filter(v => upper(v && v.type) === 'BODY')
  const urlVars = variables.filter(v => {
    const t = upper(v && v.type)
    const f = lower(v && v.format)
    if (t === 'URL') return true
    if ((t === 'BUTTONS' || t === 'BUTTON') && f === 'text') return true
    return false
  })

  return components.map(comp => {
    if (!comp || typeof comp !== 'object') return comp
    const type = upper(comp.type)
    const format = upper(comp.format)

    if (type === 'HEADER') {
      if (format === 'TEXT') {
        const headerExamples = []
        headerTextVars.forEach(v => {
          const text = safeStr(v && v.text).trim()
          if (!text) return
          setExampleAtVIndex(headerExamples, v && v.vIndex, text)
        })
        if (!hideTemplateExamplesWhenUnset && headerExamples.length === 0) return comp
        return { ...comp, example: { header_text: headerExamples } }
      }
      if (['IMAGE', 'VIDEO', 'DOCUMENT'].includes(format)) {
        const link = pickMediaLink(headerMediaVar)
        if (!link) {
          if (!hideTemplateExamplesWhenUnset) return comp
          const { example, ...withoutExample } = comp
          return withoutExample
        }
        const nextComp = { ...comp, example: { header_handle: [link] } }
        const headerFileName = safeStr(headerMediaVar && headerMediaVar.fileName).trim()
        if (headerFileName) {
          nextComp.fileName = headerFileName
        }
        if (headerMediaVar) {
          nextComp.documentSet = true
        }
        return nextComp
      }
      return comp
    }

    if (type === 'BODY') {
      const bodyExamples = []
      bodyVars.forEach(v => {
        const text = safeStr(v && v.text).trim()
        if (!text) return
        setExampleAtVIndex(bodyExamples, v && v.vIndex, text)
      })
      if (!hideTemplateExamplesWhenUnset && bodyExamples.length === 0) return comp
      return { ...comp, example: { body_text: [bodyExamples] } }
    }

    if (type === 'BUTTONS') {
      const buttons = Array.isArray(comp.buttons) ? comp.buttons : []
      if (buttons.length === 0) return comp
      let urlVarCursor = 0
      const nextButtons = buttons.map(btn => {
        if (!btn || typeof btn !== 'object') return btn
        const btnType = upper(btn.type)
        if (btnType !== 'URL') return btn
        const urlTemplate = safeStr(btn.url)
        if (!/\{\{\d+\}\}/.test(urlTemplate)) return btn
        const v = urlVars[urlVarCursor]
        urlVarCursor += 1
        const text = safeStr(v && v.text).trim()
        if (!text) {
          if (!hideTemplateExamplesWhenUnset) return btn
          return { ...btn, example: [] }
        }
        const example = []
        setExampleAtVIndex(example, v && v.vIndex, text)
        return { ...btn, example }
      })
      return { ...comp, buttons: nextButtons }
    }

    return comp
  })
}
